module.exports = __webpack_public_path__ + "static/media/Icon_menu_policy.5323ed73.svg";